var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "compare-col" }, [
    _c("div", { staticClass: "compare-block" }, [
      _c("span", { staticClass: "icon-common-file-text-add" }),
      _c(
        "button",
        {
          staticClass: "button",
          on: {
            click: function ($event) {
              return _vm.compareWithAnotherProfile()
            },
          },
        },
        [_vm._v(" Compare with Another Profile ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }